import edap, {GENERIC_EVENT} from '../utils/edap';

export const CATEGORY = 'scratchpad';

// generic events
export const generic = {
    RECENT_ACTIVITY_SEARCH: 'fullpage:recentactivitysearch',
    SUMMARY_CLICK: 'fullpage:parentclick',
    SUMMARY_INITIAL_LOAD: 'fullpage:load',
    SEE_MORE_CLICK: 'fullpage:continuesearchclick',
    REMOVE_SEARCH_CLICK: 'fullpage:searchremove_parent',
    REMOVE_PROPERTY_CLICK: 'fullpage:listingremove_child',
    BEST_MATCH_CLICK: 'fullpage:recpropclick',
    BEST_MATCH_ARROW_CLICK: 'fullpage:recoarrowclick',
    CHANGE_SEEN: 'changeSeen'
};

// generic event utility methods
const trigger = (data) => {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        ...data
    });
};


const triggerDelay = (data) => {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        ...data
    }, {
        delayProcessing: true
    });
};

// generic event methods
generic.seeMoreClick = (label = '') => {
    triggerDelay({
        eventaction: generic.SEE_MORE_CLICK,
        eventlabel: label
    });
};

generic.removeSearchClick = () => {
    trigger({
        eventaction: generic.REMOVE_SEARCH_CLICK
    });
};

generic.removePropertyClick = () => {
    trigger({
        eventaction: generic.REMOVE_PROPERTY_CLICK
    });
};

generic.bestMatchClick = (label = 0) => {
    trigger({
        eventaction: generic.BEST_MATCH_CLICK,
        eventlabel: label
    });
};

generic.bestMatchNextArrowClick = () => {
    trigger({
        eventaction: generic.BEST_MATCH_ARROW_CLICK,
        eventlabel: 'right'
    });
};

generic.bestMatchPreviousArrowClick = () => {
    trigger({
        eventaction: generic.BEST_MATCH_ARROW_CLICK,
        eventlabel: 'left'
    });
};

generic.changeSeenEvent = (position = 0, total = 0, scratchpadId = '') => {
    trigger({
        eventaction: generic.CHANGE_SEEN,
        eventlabel: `${edap.getPositionLabel(position, total)};spid=${scratchpadId}`
    });
};

generic.recentActivitySearch = (position = 0, total = 0, lbsUuid = '') => {
    trigger({
        eventaction: generic.RECENT_ACTIVITY_SEARCH,
        eventlabel: `${edap.getPositionLabel(position, total)};lbsUuid=${lbsUuid}`
    });
};

// named events (edap-integrations@8.6.0)
export const named = {
    RECENT_ACTIVITY_MORE_CLICK: 'recentactivity.seemore.click',
    RECENT_ACTIVITY_DELETE: 'recentactivity.search.delete',
    RECENT_ACTIVITY_REMOVE: 'recentactivity.individual.delete',
    RECENT_ACTIVITY_VIEW: 'recentactivity.view'
};

export const MORE_LOCATION = {
    BOTTOM: 'bottom',
    TOP: 'top'
};

const getSearchTerm = (searchTerm) => searchTerm && searchTerm.toLowerCase() || '';

export const MORE_TYPE = {
    top: 'see more',
    bottom: 'see more in x'
};

named.delete = function(eventsearchterm) {
    const searchterm = getSearchTerm(eventsearchterm);
    edap.trigger(named.RECENT_ACTIVITY_DELETE, {eventsearchterm: searchterm});
};

named.remove = function(eventsearchterm, listingIds = []) {
    const eventlistingids = listingIds.join(',');
    const searchterm = getSearchTerm(eventsearchterm);
    edap.trigger(named.RECENT_ACTIVITY_REMOVE, {
        eventsearchterm: searchterm,
        eventlistingids
    });
};

named.seeMoreClick = function(location) {
    edap.trigger(named.RECENT_ACTIVITY_MORE_CLICK, {
        seemoretype: MORE_TYPE[location]
    });
};

named.view = function(eventsearchterm) {
    const searchterm = getSearchTerm(eventsearchterm);
    edap.trigger(named.RECENT_ACTIVITY_VIEW, {eventsearchterm: searchterm});
};

const methods = {
    bestMatchClick: generic.bestMatchClick,
    bestMatchNextArrowClick: generic.bestMatchNextArrowClick,
    bestMatchPreviousArrowClick: generic.bestMatchPreviousArrowClick,
    changeSeenEvent: generic.changeSeenEvent,
    recentActivitySearch: generic.recentActivitySearch,
    removePropertyClick(searchTerm, listingIds) {
        listingIds = !Array.isArray(listingIds) ? [listingIds] : listingIds;
        generic.removePropertyClick();
        named.remove(searchTerm, listingIds);
    },

    removeSearchClick(searchTerm) {
        generic.removeSearchClick();
        named.delete(searchTerm);
    },

    seeMoreClick(location) {
        generic.seeMoreClick(location);
        named.seeMoreClick(location);
    },

    viewRecentActivityDetails: named.view
};

export default {
    generic,
    named,
    ...methods
};



// WEBPACK FOOTER //
// ./src/universal/recent-activity/edap.js